export default __webpack_public_path__ + "static/media/bank-interest.76669d63.svg";